import React from 'react';
import { Link } from 'react-router-dom';

import './breadcrumb.css';

class Breadcrumb extends React.Component {
    render() {
        const lastIndex = this.props.items.length - 1;
        return (
            <div className='breadcrumb'>
                {this.props.items
                    .map((item, idx) =>
                        <div key={idx}>
                            <Link to={item.url}>
                                <span className={(idx === lastIndex) ? 'last-item' : ''}>{item.title}</span>
                            </Link>
                            {(idx !== lastIndex) && <span className='breadcrumb-separator'>{'>'}</span>}
                        </div>
                    )
                }
            </div>
        );
    }
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/breadcrumb/breadcrumb.js